<template>
  <div v-if="likeList" class="likeList">
		<ul>
			<li v-for="item in datas" v-bind:key="item.id">
				<img class="portrait" v-if="item.avatar" :src="item.avatar" />
				<img @click="dianzan" v-if="!item.avatar" src="@/assets/add-red.png" />
			</li>
		</ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'likeList',
  data(){
	  return {

	  }
  },
  props:['likeList'],
  computed: {

		datas(){
			var _d = [{ avatar : '',id : '1'},
			{ avatar : '',id : '2'},
			{ avatar : '',id : '3'},
			{ avatar : '',id : '4'},
			{ avatar : '',id : '5'},
			{ avatar : '',id : '6'}];

			_d.splice(0,this.likeList.length,...this.likeList);

			return _d;
		}
  },
  created(){


  },
  methods: {
  	dianzan() {
  		this.$store.commit('showQrCode',`
  		${ solution_host }/campaigns/try/mobile-c/#/show/`+this.$route.params.id);
  	}
  },
  components: {

  }
}
</script>

<style>
	.likeList ul{
		 display: flex;
		 flex-direction:row;
		 align-items: center;
		 justify-content: center;
	}

	.likeList li{
		 margin-right: 0.08421rem;
	}

	.likeList li:last-child{
		 margin-right: 0px;
	}

	.likeList img{
		width: 0.352631rem;
	}
</style>
